module.exports = __webpack_public_path__ + "img/profit_detail.cb167f52.svg";